module.exports = __webpack_public_path__ + "static/media/SearchGreen.9d2bbfad.svg";